export default __webpack_public_path__ + "static/media/vp.8acabf53.png";